import React from 'react';
import PropTypes from 'prop-types';
import styles from './Benefits.module.sass';

function Benefits(props) {
  const {
    featuresContent, previewText, pageColor,
  } = props;
  return (
    <div className={styles.wrapper}>
      <div className={styles.info} dangerouslySetInnerHTML={{ __html: featuresContent }} />
      <span className={styles['preview-text']} style={pageColor ? { color: pageColor } : null}>
        {previewText}
      </span>
    </div>
  );
}

Benefits.propTypes = {
  featuresContent: PropTypes.string,
  previewText: PropTypes.string,
  pageColor: PropTypes.string,
};

export default Benefits;
